<template>
<van-cell-group v-if="schema.type=='textarea'">
  <van-field :name="schema.name + '_' +schema.uniqid" 
  v-model="schema.text" rows="3" autosize show-word-limit 
  maxlength="255" 
  :label="schema.label" 
  :placeholder="schema.label" 
  :type="schema.type"  
  :required="schema.required" 
  :readonly="schema.readonly" 
  :disabled="schema.disabled"
  :rules="[{ required: schema.required ,message:'请输入'+schema.label}]"
  />
</van-cell-group>
<van-cell-group v-else>
  <van-field 
  :name="schema.name + '_' +schema.uniqid" 
  v-model="schema.text" 
  :label="schema.label" 
  :placeholder="schema.label" 
  :type="schema.type"  
  :required="schema.required" 
  :readonly="schema.readonly" 
  :disabled="schema.disabled"
  :rules="[{ required: schema.required ,message:'请输入'+schema.label}]"
  >
    <!-- <template v-if="schema.isScan" #right-icon>
      <van-icon name="scan" :color="schema.scanColor" size="22"/>
    </template> -->
  </van-field>
</van-cell-group>
  
</template>

<script>
import { Notify } from 'vant';

export default {
  name: 'field',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  methods:{
    onScan(){
      Notify({ type: 'warning', message: '点击了扫码',duration: 800 });
    }
  }
}
</script>

<style>

</style>